export default "__VITE_ASSET__CkKHTCLN__"